import { useState, forwardRef, useEffect } from "react";
import { useParams, useNavigate} from 'react-router-dom';
import { useForm, Controller, useFieldArray  } from 'react-hook-form';
import { Col, Row, Card } from "react-bootstrap";
import DatosCabezaFamilia from './../Caracterizacion/DatosCabezaFamilia';
import DataTable from 'react-data-table-component';
import apiService from '../../Auth/apiService';
import { Mensaje } from '../../services/mensajeService';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import MenuCaracterizacion from "../Caracterizacion/Componentes/MenuCaracterizacion";
import { BotonEditar } from "../Utils/BotonEditar";
import NumberInput from "../Utils/NumberInput";
import { useAuth } from "../../Auth/AuthContext";
import { FaCalendar } from 'react-icons/fa';
import PropTypes from 'prop-types';
import SeccionPageHeader from "../Utils/SeccionPageHeader";
import CargandoSpinner from "../Utils/CargandoSpinner";
import SearchForm from '../Utils/Searchform';

registerLocale('es', es);
setDefaultLocale('es');

const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick()}
        ref={ref}
        tabIndex={0}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
    >
        <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }}/>
        <FaCalendar size={20} color="black" />
    </button>
    ));

CustomInput.propTypes = {
    value: PropTypes.any,
    onClick: PropTypes.func,
};
function BotonEliminar(row, Borraratencion) {
    return (<BotonEditar Editar={Borraratencion} row={row}></BotonEditar>);
}
export default function Albergue(){    
    const { token, rol, user, sedeActual } = useAuth();
    const usrRolid = rol;
    const navigate = useNavigate();
    const [cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [searchTerm, setSearchTerm] = useState('');
    const { control, handleSubmit, register, setValue, getValues, reset, formState: { errors }} = useForm();
    const { append, remove } = useFieldArray({
        control,
        name: 'alberguefields'
      });
    const [MostrarAyuda, setMostrarAyuda] = useState(false);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const [entidades, setEntidades] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const [ayudas, setAyudas] = useState([]);
    const handleSearch = (event) => {
        event.preventDefault();
        if (searchTerm.trim() !== '') {
            navigate(`/albergues/albergue/${searchTerm}`, { replace: true });
        }
    };
    useEffect(() => {
    
        const fetchData = async () => {
            let url = '/albergue/crearformularioregistroalbergue';
          
            let obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: usrRolid }
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
                setEntidades(result.entidades);
                setIntegrantes(result.integrantesdto);
                ResetForm();
                setValue('entidad', 0);
                setValue('usrId', user);
                setValue('cabIdcabezafamilia', idCabezaFamilia);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
            
            
        };
        fetchData();
    }, [idCabezaFamilia, token, usrRolid, user, setValue]);
    const onSubmit = async (data) => {
        const ExisteAtencion = getValues('alberguefields').find((item) => item.idayuda === data.idayuda && item.idpersona === data.idpersona);
        if(!ExisteAtencion){
            const nombreayuda = ayudas.find((item) => item.id === data.idayuda).ayu_ayuda;
            const nombreentidad = entidades.find((item) => item.id == data.entidad).entEntidad;
            append({
                idayuda: data.idayuda, 
                cantidad: data.cantidad, 
                valor : data.valorunitario,
                observaciones: data.observaciones,
                fecha: data.fecha, 
                identidad: data.entidad,
                ayuda: nombreayuda, 
                entidad : nombreentidad,
                idpersona: data.idpersona
            });
        }else {
            Mensaje('Registrar atencion', "ya esta registrada esta atencion");
        }
        
    };
   
    const columns = [
        {
            name: 'Acciones',
            cell: row => BotonEliminar(row, Borraratencion),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Ayuda', selector: row => row.ayuda, sortable: true, width:'10%' },
        { name: 'Entidad', selector: row => row.entidad, sortable: true, width: '15%' },
        { name: 'Cantidad', selector: row => row.cantidad, sortable: true, width: '10%' },
        { name: 'Valor', selector: row => Math.round(row.valor), sortable: true, width: '10%' },
        { name: 'Observaciones', selector: row => row.observaciones, sortable: true, width: '55%' }
    ];
    function Borraratencion (row){
        remove(getValues('alberguefields').indexOf(row));
    };
    const GuardarAlbergues = async () => {
        const values = getValues();
        setCargando(true);
        let url;
        url = '/albergue/registraroalbergue';
        try {
            const response = await apiService.post(url, values, token);
            if(response.status === 200){
                Mensaje('Registrar atencion', JSON.stringify(response.data), 'success');
                reset({
                    atencionesfields: []
                  });
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data.errors), 'error');
            }else if(error.status === 409){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data), 'error');
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            ResetForm();
        }

      };
     const ResetForm = () => {
        const fechahoy = new Date()
        setValue('fecha', fechahoy);
        setValue('idpersona', '');
        setValue('entidad', 0);
        setValue('cantidad', 0);
        setValue('idayuda', '');
        setValue('valorunitario', 0);
        setValue('observaciones', '');
        setValue('sede', sedeActual);
        setMostrarAyuda(false);
    }
    const ActualizarAyudas = async (event) => {
        let url = '/albergue/consultarayudasentidad';
        let obj = {identidad: event.target.value }
        try {
            setCargando(true);
            const responseayudas = await apiService.post(url, obj, token);
            const resultayudas = await responseayudas.data.ayudas;
            if(resultayudas.length > 0){
                setMostrarAyuda(true);
                setAyudas(resultayudas);
            }else{
                setMostrarAyuda(false);
                setAyudas([]);
                setValue('idayuda', '')
            }
            
            setValue('entidad', event.target.value)
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
      };
    
    return (
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Registro ingreso albergues"
                idCabezaFamilia={idCabezaFamilia}
                url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`}
                nombreurl="Grupo familiar"
                nombreform="Ingreso albergue"/>
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia}></MenuCaracterizacion>
                    <SearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} handleSearch={handleSearch} Cargando={cargando} />
                    <Row >
                        <Col md={12}>
                            <Card className="mb-3">
                                <Card.Header as="h5">Registrar albergue</Card.Header>
                                <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <Card.Body>
                                    <DatosCabezaFamilia datos={CabezaFamiliaDatos}></DatosCabezaFamilia>
                                    <input hidden {...register('usrId')}/>
                                    <input hidden {...register('cabIdcabezafamilia')}/>
                                    <input hidden {...register('sede')}/>
                                    <Row>
                                        <Col md={4}>
                                            <div className="form-group" >
                                                <label htmlFor="entidad">Entidad: </label>
                                                <select id="entidad" {...register('entidad', { required: true })} className='form-control' onChange={ActualizarAyudas}>
                                                    <option value="0">Seleccionar</option>
                                                    {entidades.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                    {option.id} {option.entEntidad}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.entidad && <p style={{color: 'red'}}>Seleccione entidad</p>}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group" >
                                                <label htmlFor="idpersona">Integrante:</label>
                                                <select id="idpersona" {...register('idpersona', { required: true })} className='form-control'>
                                                    <option value="">Seleccionar</option>
                                                    {integrantes.map((option) => (
                                                    <option key={option.per_idpersona} value={option.per_idpersona}>
                                                        {option.par_parentesco} {option.per_idpersona} {option.nombre}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.idpersona && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group" >
                                                <label htmlFor="idayuda">Ayuda: </label>
                                                <select id="idayuda" {...register('idayuda', { required: true })} className='form-control' disabled={!MostrarAyuda}>
                                                    <option value="">Seleccionar</option>
                                                    {ayudas.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                    {option.id} {option.ayu_ayuda}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.idayuda && <p style={{color: 'red'}}>Seleccione tipo ayuda</p>}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <div className="form-group" >
                                                <label htmlFor="valorunitario">Valor Total:</label>
                                                <Controller
                                                    name="valorunitario"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <NumberInput {...field} />
                                                    )}
                                                />
                                                {errors.valorunitario && <p style={{color: 'red'}}>Digite valor unitario</p>}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group" >
                                                <label htmlFor="cantidad">Cantidad: </label>
                                                <Controller
                                                    name="cantidad"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={{ required: 'Cantidad es requerida', min: { value: 1, message: 'Minimo 1' } }}
                                                    render={({ field }) => (
                                                        <NumberInput {...field} id="cantidad" />
                                                    )}
                                                />
                                                {errors.cantidad && <p style={{color: 'red'}}>Digite cantidad</p>}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                    <label htmlFor="fecha">Fecha ingreso:</label>
                                                    <Controller
                                                        control={control}
                                                        name="fecha"
                                                        render={({ field }) => (
                                                            <DatePicker
                                                            placeholderText="fecha"
                                                            onChange={(date) => field.onChange(date)}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value}
                                                            customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            minDate={new Date(new Date().getFullYear(), 0, 1)}
                                                            maxDate={new Date()}
                                                            />
                                                        )}
                                                    />
                                                    {errors.fecha && <p style={{color: 'red'}}>Digite fecha de entrega</p>}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <div className='row'>
                                                <div className="col-md-12">
                                                    <label htmlFor="observaciones">Observaciones</label>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className="col-md-12">
                                                <textarea className='form-control' rows={3} style={{ width: '100%' }}
                                                    {...register('observaciones', { required: true })}
                                                    placeholder="observaciones"
                                                />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Card.Footer>
                                        <button type="submit" className="btn btn-primary">Agregar</button>
                                    </Card.Footer>
                                    <Row>
                                        <Col md={12}>
                                            <div className="card-body table-responsive p-0">
                                                <DataTable
                                                    title="Albergue"
                                                    columns={columns}
                                                    data={getValues('alberguefields')}    
                                                    progressPending={cargando}
                                                    pagination
                                                    noDataComponent="No hay datos para mostrar"
                                                /> 
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                                <Card.Footer>
                                    <button type="button" onClick={GuardarAlbergues} className="btn btn-primary">Guardar</button>
                                </Card.Footer>
                                </form>
                                
                            </Card>
                        </Col>
                    </Row>
                </div>
            </section>
        </div>
    );
}